import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const LibrarySearchSchema = z.object({
  componentDefinitionIds: z
    .array(z.string().min(1))
    .min(1)
    .optional()
    .catch(undefined),
  componentReferenceId: z.string().optional().catch(undefined),
  ratings: z.array(z.number()).min(1).optional().catch(undefined),
})

export type LibrarySearch = z.infer<typeof LibrarySearchSchema>

export const Route = createFileRoute('/_authenticated/$workspaceId/library')({
  validateSearch: (raw) => LibrarySearchSchema.parse(raw),
})
